import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
  socialIcons: {
    color: theme.palette.primary.main,
    margin: "0px 5px",
    cursor: "pointer",
  },
  inlineBlock: {
    display: "inline-block",
  },
  mobileCenteredText: {
    [theme.breakpoints.down("sm")]: {
      margin: "0 auto",
    },
  },
  iconGroup: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));
